import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPhotography,
  editPhotography,
  deletePhotography,
  insertPhotography,
  fetchPhotographyById,
  fetchPhotographyByCategory,
} from "./photographyThunks";

// Slice
const photographySlice = createSlice({
  name: "photography",
  initialState: {
    fetchPhotographypending: true,
    Photographylist: null,
    fetchPhotographyrejected: null,

    fetchPhotographyByIdpending: true,
    PhotographyById: null,
    fetchPhotographyByIdrejected: null,

    insertPhotographypending: true,
    insertPhotographyfulfilled: null,
    insertPhotographyrejected: null,

    editPhotographyfulfilled: null,
    editPhotographyrejected: null,
    editPhotographypending: true,
    isDelete: false,

    status: "idle",
    error: null,
  },
  reducers: {
    resetInsertPhotography: (state) => {
      state.insertPhotographypending = true;
      state.insertPhotographyfulfilled = null;
    },
    // resetEditPhotography:(state)=>{
    //   state.editPhotographyfulfilled=null,
    //   state.editPhotographyrejected=null,
    //   state.editPhotographypending=true
    // },
    resetisDelete: (state) => {
      state.isDelete = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhotography.pending, (state) => {
        state.fetchPhotographypending = true;
      })
      .addCase(fetchPhotography.fulfilled, (state, action) => {
        state.fetchPhotographypending = false;
        if ( action.payload?.pagination?.page==1) {
          state.Photographylist = action.payload.data;
        } else {
          action.payload.data.forEach((item) => {
            if (
              !state.Photographylist.some(
                (existingItem) => existingItem._id === item._id
              )
            ) {
              state.Photographylist.push(item);
            }
          });
        }

        state.pagination = action.payload?.pagination;
      })
      .addCase(fetchPhotographyByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPhotographyByCategory.fulfilled, (state, action) => {
        state.loading = false;

        if (state.Photographylist == null) {
          state.Photographylist = action.payload.data;
        } else {
          // Filter out items that do not belong to the category of the first item in action.payload.data
          state.Photographylist = state.Photographylist.filter(
            (item) => item.category === action?.payload?.data[0]?.category
          );

          // Loop through the incoming data to add unique items
          action.payload.data.forEach((item) => {
            const exists = state.Photographylist.some(
              (existingItem) => existingItem._id === item._id
            );
            if (!exists) {
              // Push the item if it's unique by _id
              state.Photographylist.push(item);
            }
          });
        }

        state.pagination = action.payload.pagination || {};
      })

      .addCase(fetchPhotographyByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.Photographylist = [];
        state.pagination = null;
      })
      .addCase(fetchPhotography.rejected, (state, action) => {
        state.fetchPhotographypending = false;
        state.fetchPhotographyrejected = action.payload;
      })
      .addCase(fetchPhotographyById.pending, (state) => {
        state.fetchPhotographyByIdpending = true;
      })
      .addCase(fetchPhotographyById.fulfilled, (state, action) => {
        state.fetchPhotographyByIdpending = false;
        state.PhotographyById = action.payload;
      })
      .addCase(fetchPhotographyById.rejected, (state, action) => {
        state.fetchPhotographyByIdpending = false;
        state.fetchPhotographyrejected = action.payload;
      });
  },
});
export const { resetInsertPhotography, resetEditPhotography, resetisDelete } =
  photographySlice.actions;
export default photographySlice.reducer;
